import { SandboxMessengerService } from './sandbox-messenger.service';
import { SnapLayerAPIService } from './../model/api-services/snap-layer-api.service';
import { Injectable } from '@angular/core';
import { Decorable } from '../types/decorable';

import { SLMap } from '../model/sl-map';
import { GeoService } from './geo.service';
import { SLLayer } from '../model/sl-layer';
import { EnvService } from '../env.service';
import { LayerListProviderService } from './layer-list-provider.service';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';
import { SaveMapDialogService } from '../components/dialogs/save-map-dialog/save-map-dialog-service.';
import { LoadMapDialogService } from '../components/dialogs/load-map-dialog/load-map-dialog-service';
import { MapApiService } from '../model/api-services/map-api.service';
import { ResultsService } from './results.service';

@Injectable({
	providedIn: 'root'
})
export class MapService {
  public static maps:Array<SLMap>;
	private maps: Array<SLMap>;
	private layers: Array<SLLayer>;
	constructor(
		private geoService: GeoService,
		private envService: EnvService,
		private layerListSvc: LayerListProviderService,
		private messager: ModalMessagerService,
		private saveDialogService: SaveMapDialogService,
		private loadDialogService: LoadMapDialogService,
		private mapAPIService: MapApiService,
		private resultsSvc: ResultsService,
    private snapLayerSvc:SnapLayerAPIService,
    private sandboxMsgrSvc:SandboxMessengerService) {
		MapService.maps = [];
		this.layers = [];
		this.layers = this.layers;
	}
	NewMap(src: any): SLMap {
		MapService.maps.push(
			new SLMap(
				this.geoService,
				this.envService,
				this.layerListSvc,
				this.messager,
				this.saveDialogService,
				this.loadDialogService,
				this.mapAPIService,
				this.resultsSvc,
        this.snapLayerSvc,
        this.sandboxMsgrSvc,
				src));
		const map: SLMap = MapService.maps.slice(-1).pop();
		return map;
	}
	RemoveMap(map: SLMap) {
		map.Destroy();
		const i: number = MapService.maps.indexOf(map);
		MapService.maps.splice(i, 1);
	}
  static GetById(id:string):Decorable | null {
		for (const map of MapService.maps) {
			if (map.id !== id) {
				continue;
			}
			return map;
		}
		return null;
  }
	GetMapById(id: string): Decorable | null {
		return MapService.GetById(id);
	}
	public static Get(index?:number): SLMap {
		if(!!index) {
			return MapService.maps[index];
		}
		if(MapService.maps.length <= 0) {
			return null;
		}
		return MapService.maps[MapService.maps.length -1];
	}
	GetMap(index?:number): SLMap {
		return MapService.Get(index);
	}




}
